import React, { FC, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";
import navToggleBtn from "../../assets/images/heroicons_md-menu-alt-3.svg";
interface NavigationbarProps {
  openFullScreenModal: () => void;
}

export const Navigationbar: FC<NavigationbarProps> = ({
  openFullScreenModal,
}) => {
  const [isScrolling, setIsScrolling] = useState<boolean>();
  useEffect(() => {
    const navScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolling(true);
      } else {
        setIsScrolling(false);
      }
    };
    window.addEventListener("scroll", navScroll);
    return () => {
      window.removeEventListener("scroll", navScroll);
    };
  });
  return (
    <div className={`navMenu ${isScrolling ? "isScrolling" : ""} fixed-top`}>
      <div className="container">
        <nav className="navbar navbar-light navbar-expand-lg my-3">
          <Link className="navbar-brand" to="/">
            <h2>
              Speed<span>nance.</span>
            </h2>
          </Link>
          <button
            onClick={openFullScreenModal}
            className="navToggler d-lg-none"
          >
            <img src={navToggleBtn} alt="toggle" />
          </button>
          <div className="collapse navbar-collapse" id="navbar">
            <ul className="navbar-nav">
              <li className="nav-item">
                <ScrollLink
                  smooth={true}
                  className="navLink mt-1"
                  spy={true}
                  offset={-205}
                  duration={500}
                  to="about"
                >
                  About
                </ScrollLink>
              </li>
              <li className="nav-item">
                <ScrollLink
                  smooth={true}
                  className="navLink mt-1"
                  spy={true}
                  offset={-180}
                  duration={500}
                  to="payments"
                >
                  Payments
                </ScrollLink>
              </li>
              <li className="nav-item">
                <ScrollLink
                  smooth={true}
                  className="navLink mt-1"
                  spy={true}
                  duration={500}
                  to="contact"
                >
                  Contact
                </ScrollLink>
              </li>
            </ul>
            <ul className="navbar-nav ml-auto">
              <li className="nav-item">
                <Link className="navLink mt-1" to="/login">
                  Log in
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/register"
                  className="primary-btn my-3 my-sm-0 ml-lg-3"
                >
                  Get Started
                </Link>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  );
};

export const AuthNav: FC<{}> = () => {
  return (
    <div className="navMenu hide-nav  fixed-top bg-white ">
      <div className="container-fluid">
        <nav className="navbar navbar-light navbar-expand-lg my-1 my-md-4">
          <Link className="navbar-brand" to="/">
            <h2>
              Speed<span>nance.</span>
            </h2>
          </Link>
        </nav>
      </div>
    </div>
  );
};
